import { render, staticRenderFns } from "./GrnCreate.vue?vue&type=template&id=61dd32b8"
import script from "./GrnCreate.vue?vue&type=script&lang=js"
export * from "./GrnCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports